// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"19d2f164","245":"5001275e","493":"6624ac4e","694":"c3802654","752":"5299c21e","787":"37faa4c4"}[chunkId] + ".chunk.js";
};